<template>
  <div class="more">
    <div class="card-box">
      <div class="title">
        <span>{{ data.report?.inspectItem }}</span>
      </div>
      <div class="row">
        <span>报告单号：</span>
        <span>{{ bgdh }}</span>
      </div>
      <div class="row">
        <span>报告类型：</span>
        <span>{{ data.report?.inspectType }}</span>
      </div>
      <div class="row">
        <div class="left">
          <span>姓名：</span>
          <span>{{ data.report?.patName }}</span>
        </div>
        <div>
          <span>性别：</span>
          <span>{{ data.report?.sex }}</span>
        </div>
      </div>
      <div class="row">
        <div class="left">
          <span>年龄：</span>
          <span>{{ data.report?.age }}</span>
        </div>
        <div>
          <span>科室：</span>
          <span>{{ data.report?.applyDeptName }}</span>
        </div>
      </div>
      <div class="row">
        <span>样本种类：</span>
        <span>{{ data.report?.sampleName }}</span>
      </div>
      <div class="row">
        <span>临床诊断：</span>
        <span>{{ data.report?.diagnosisName }}</span>
      </div>
      <div class="row">
        <span>采样日期：</span>
        <span>{{ data.report?.collectTime }}</span>
      </div>
      <div v-if="data.report?.source==='2'" class="row">
        <div class="left">
          <span>病区：</span>
          <span>{{ data.report?.ward }}</span>
        </div>
        <div>
          <span>床号：</span>
          <span>{{ data.report?.bedNumber }}</span>
        </div>
      </div>
      <div class="row">
        <div class="left">
          <span>检验医师：</span>
          <span>{{ data.report?.inspectDocName }}</span>
        </div>
        <div>
          <span>报告医师：</span>
          <span>{{ data.report?.reportDocName }}</span>
        </div>
      </div>
      <!-- <div class="row">
        <span>核对者：</span>
        <span>{{ data.hdz }}</span>
      </div> -->
      <div class="row">
        <span>检验日期：</span>
        <span>{{ data.report?.inspectTime }}</span>
      </div>
      <div class="row">
        <span>报告日期：</span>
        <span>{{ data.report?.reportTime }}</span>
      </div>
      <!-- <div class="row">
        <span>发布日期：</span>
        <span />
      </div> -->
      <!-- <div class="row mb0">
        <span>备注：</span>
        <span />
      </div> -->
    </div>
  </div>
</template>

<script>
import {patientModel} from "../../../api/patient"

export default {
  name: 'CheckoutMore',
  
  data() {
    return {
      data:{},
      patId: this.$route.query.patId ||'',
      bgdh:this.$route.query.bgdh
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData(){
      let params={
        patientId: this.$route.query.patId ||'',
        inspectionNo: this.$route.query.bgdh ||''
      }
      patientModel.inspectionReportDetail(params).then(res=>{
        this.data = res.data
      })
    }
  }
}
</script>

<style scoped lang='less'>
@import "../../../assets/styles/variable.less";
.more {
  padding: 32px;

  .card-box {
    width: 100%;
    background: #FFFFFF;
    border-radius: 12px;
    padding: 32px;
    box-sizing: border-box;

    .title {
      font-size: 32px;
      font-weight: bold;
      color: #3D3D3D;
      line-height: 45px;
      margin-bottom: 32px;
    }

    .row {
      display: flex;
      line-height: 40px;
      font-size: 28px;
      margin-bottom: 24px;
      color: #666666;

      .left {
        text-align: left;
        width: 325px;
      }    
    }

    .mb0 {
      margin-bottom: 0px;
    }
  }
}

</style>
